<template>
  <div class="focusNav">
    <div class="indexContainer">
      <el-divider class="indexTitle" v-if="val.title">
        <div class="indexTitleMain indexBg">
          <h3 v-if="val.languageId = 1">{{val.title ? val.title : ''}}</h3><br />
          <h4>{{val.summary}}</h4>
        </div>
      </el-divider>
      <el-container style="padding-top:20px">
        <el-row style="width:100%">
          <el-col :md="14" :sm="24">
            <div class="pic">
              <el-carousel :interval="5000" arrow="never" @change="carouselChange">
                <el-carousel-item v-for="list in imgList" :key="list.id">
                  <div class="carouselCu" @click="imgClick(list)">
                    <img :src="list.imgUrl" alt="" width="100%" />
                    <h3>{{ list.title }}</h3>
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>
          </el-col>
          <el-col :md="10" :sm="24">
            <el-tabs tab-position="right" v-model="tabName">
              <el-tab-pane v-for="(item,index) in val.modules[0].articles" :key="index" :name="'nav_'+index">
                <span slot="label" class="focusNavTab" @click="rowClick(item)">
                  <div class="ico">{{'0'+ (index+1)}}</div>
                  <div class="title">
                    <p>{{item.title}}</p>
                    <span>{{item.releaseTime|dateFormat}}</span>
                  </div>
                </span>
              </el-tab-pane>
            </el-tabs>
          </el-col>
        </el-row>

      </el-container>
      <el-row style="width: 100%">
        <el-button class="more" round @click="handleShow">{{val.moreText}}</el-button>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    val: {},
  },
  data() {
    return {
      tabName: '',
      index: 0,
      moduleId: '',
      imgList: [],
    }
  },
  computed: {},
  created() {
    this.val.modules[0].articles = this.val.modules[0].articles.splice(0, 4)
    this.moduleId = this.val.moduleId
    this.getImgList()
  },
  methods: {
    getImgList() {
      let imgArr = []
      if (this.val.modules) {
        for (let v of this.val.modules[0].articles) {
          imgArr.push({ imgUrl: v.picUrl, title: v.title, id: v.id })
        }
      }
      this.imgList = imgArr
    },
    handleShow() {
      let routerURL = this.$router.resolve({
        name: 'INNERPAGER',
        query: {
          model: this.val.module.model,
          moduleId: this.val.module.parentId,
          // moduleId:this.moduleId,
          // id: this.val.module.id,
          id: this.val.module.parentId,
          level: 2,
          type: Number(this.val.module.model) === 1 ? 2 : 1,
          languageId: this.val.module.languageId,
        },
      })
      window.open(routerURL.href, '_blank')
    },
    rowClick(row) {
      let routerPath = this.$router.resolve({
        name: 'ARTICLEDETAIL',
        query: {
          languageId: this.$route.query.languageId,
          model: this.$route.query.model,
          moduleId: this.moduleId,
          modelId: this.$route.query.id,
          level: this.$route.query.level,
          type: this.$route.query.type,
          id: row.id,
        },
      })
      window.open(routerPath.href, '_blank')
    },
    imgClick(img) {
      const article = this.val.modules[0].articles.find((o) => o.id === img.id)
      this.rowClick(article)
    },
    carouselChange(nowIndex, oldIndex) {
      this.tabName = 'nav_' + nowIndex
    },
  },
  watch: {
    val(value) {},
  },
}
</script>
<style lang="less" scoped>
.focusNav {
  /deep/.el-tabs__header {
    margin: 0;
  }
  /deep/.el-tabs__item {
    height: 67px;
    margin-bottom: 2px;
    padding: 0;
  }
  /deep/.el-tabs__active-bar {
    background-color: #f7f7f7;
  }
  /deep/.el-tabs--left .el-tabs__header.is-left,
  /deep/.el-tabs--left .el-tabs__header.is-right,
  /deep/.el-tabs--left .el-tabs__nav-scroll,
  /deep/.el-tabs--left .el-tabs__nav-wrap.is-left,
  /deep/.el-tabs--left .el-tabs__nav-wrap.is-right,
  /deep/.el-tabs--right .el-tabs__header.is-left,
  /deep/.el-tabs--right .el-tabs__header.is-right,
  /deep/.el-tabs--right .el-tabs__nav-scroll,
  /deep/.el-tabs--right .el-tabs__nav-wrap.is-left {
    height: auto;
  }
  .el-tabs__item.is-active {
    .focusNavTab {
      background: #fff;
    }
  }
  .carouselCu {
    // cursor: pointer;
  }
  .pic {
    width: 100%;
    position: relative;
    img {
      height: 100%;
    }
    h3 {
      width: 100%;
      line-height: 36px;
      text-align: left;
      padding-left: 10px;
      background: rgba(0, 0, 0, 0.6);
      color: #fff;
      position: absolute;
      bottom: 0;
      margin: 0;
      font-weight: normal;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  /deep/.el-carousel__indicators--horizontal {
    left: 55%;
    .el-carousel__button {
      width: 8px;
      height: 8px;
      border-radius: 8px;
      opacity: 1;
    }
  }
  /deep/ .is-active {
    .el-carousel__button {
      background-color: #d11a2d;
    }
  }
  .focusNavTab {
    background: #f7f7f7;
    display: block;
    height: 67px;
    width: 100%;
    overflow: hidden;
    cursor: pointer;
    .ico {
      font-style: normal;
      color: #d11a2d;
      font-size: 24px;
      font-weight: bold;
      display: inline-block;
      width: 50px;
      float: left;
      line-height: 67px;
    }
    .title {
      text-align: left;
      padding: 5px;
      span {
        color: #808080;
        font-size: 14px;
      }
      p {
        margin: 0;
        font-size: 16px;
        line-height: 28px;
        color: #333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-weight: bold;
      }
    }
  }
  /deep/.el-tabs--right .el-tabs__header.is-right {
    float: none;
  }
  .el-tabs__item.is-activ {
    color: #d11a2d;
  }
  .more {
    padding: 10px 50px;
    color: #d11a2e;
    box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
    margin-bottom: 50px;
    margin-top: 20px;
  }
  .more:hover {
    background: #f7f7f7;
    border: 1px solid #dcdfe6;
  }
  .el-button:hover {
    border: 1px solid #eee;
    color: #d11a2e;
  }
  .el-button:focus {
    color: #d11a2e;
    border-color: #ccc;
    background-color: #f7f7f7;
  }
  @media (min-width: 768px) and (max-width: 1024px) {
    /deep/.el-tabs--right .el-tabs__header.is-right {
      float: right;
    }
    .focusNavTab {
      width: 368px;
      .title p {
        font-weight: normal;
      }
    }
    /deep/.el-carousel__indicators--horizontal {
      left: 80%;
    }
    .el-tabs__content {
      .pic {
        width: 455px;
      }
    }
  }
  @media (min-width: 1024px) and (max-width: 1200px) {
    /deep/.el-tabs--right .el-tabs__header.is-right {
      float: right;
    }

    .focusNavTab {
      width: 368px;
      .title p {
        font-weight: normal;
      }
    }
    /deep/.el-carousel__indicators--horizontal {
      left: 80%;
    }
    .el-tabs__content {
      .pic {
        width: 455px;
      }
    }
  }
  @media only screen and (min-width: 1200px) {
    /deep/.el-tabs--right .el-tabs__header.is-right {
      float: right;
    }
    .focusNavTab {
      width: 368px;
      .title p {
        font-weight: normal;
      }
    }
    /deep/.el-carousel__indicators--horizontal {
      left: 85%;
    }
    .el-tabs__content {
      .pic {
        width: 592px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/item/patch12.vue